(function ($) {
  Drupal.behaviors.csPageFormatterV1 = {
    attach: function (context) {
      var $cs_formatter = $('.cs-page', context);
      var $cs_menu = $('.menu__link--lvl-1.menu__link--has-children', $cs_formatter);

      $cs_menu.once().on('click', toggleSubmenu);
      function toggleSubmenu() {
        $(this).parent().toggleClass('active-submenu');
      }
    }
  };
})(jQuery);
